import { Capacitor } from '@capacitor/core/dist/esm/definitions';

declare global {
	interface Window {
		Capacitor: Capacitor;
		forceCapacitor?: boolean
	}
}

const isCapacitor = (): boolean => {
	try {
		return window.Capacitor && (window.Capacitor.platform === "android" || window.Capacitor.platform === "ios") || window.forceCapacitor!!;
	} catch (error) {
		return false;
	}
}

export default isCapacitor;